import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import {
  fetchMyConsentHistory,
  fetchMyPrivacy,
  accountKeys,
} from '@/lib/queries/account';
import { fetchBlocks } from '@/lib/queries/messaging';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { ConsentHistory } from './-components/ConsentHistory';
import { PrivacyClient } from './-components/PrivacyClient';

export const Route = createFileRoute('/_authed/settings/privacy/')({
  component: SettingsPrivacyPage,
});

function SettingsPrivacyPage() {
  const privacyQuery = useQuery({
    queryKey: identityKeys.privacy(),
    queryFn: fetchMyPrivacy,
    retry: false,
  });
  const blocksQuery = useQuery({
    queryKey: [...accountKeys.blockedMembers(), { pageSize: 50 }] as const,
    queryFn: () => fetchBlocks({ pageSize: 50 }),
  });
  // Prefetch consent history so the ConsentHistory child renders fast.
  useQuery({
    queryKey: identityKeys.consentHistory(),
    queryFn: fetchMyConsentHistory,
  });

  if (privacyQuery.isError) {
    return (
      <SettingsErrorShell
        title="Privacy and visibility"
        message="Could not load privacy settings."
      />
    );
  }
  if (privacyQuery.isLoading || !privacyQuery.data) return null;
  const data = privacyQuery.data;
  const blockedCount = blocksQuery.data?.items.length ?? 0;

  return (
    <PrivacyClient
      marketingOptIn={data.marketingOptIn}
      directoryVisibleOptIn={data.directoryVisibleOptIn}
      showCirclesOnProfile={data.showCirclesOnProfile}
      showActivityFeed={data.showActivityFeed}
      allowSearchEngineIndex={data.allowSearchEngineIndex}
      profileVisibilityScope={data.profileVisibilityScope}
      blockedCount={blockedCount}
      historySlot={<ConsentHistory />}
    />
  );
}
